// update vc name
// import ref from './_state';


export default function (ref) {

    ref.dom.select('#js-vc-name')
        .text(ref.data[ref.activeIndex].vc);

}